import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { EASE } from './Reveal';

export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce) window.scrollTo(0, 0);
  }, [pathname, reduce]);

  if (reduce) return <div>{children}</div>;

  return (
    <AnimatePresence mode="wait" initial={false} onExitComplete={() => window.scrollTo(0, 0)}>
      <motion.div
        key={pathname}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.45, ease: EASE }}
        data-testid="page-transition"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
